module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.modalContent.length === 0) ? _c('div', {
    staticClass: "a-loader--modal"
  }) : _c('div', _vm._l((_vm.modalContent), function(data) {
    return _c('div', _vm._l((data), function(value, key) {
      return _c(key, {
        tag: "component",
        attrs: {
          "data": value
        }
      })
    }), 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-387395f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ModalContent.vue
// module id = 1643
// module chunks = 0